import { EmptyState, LoadingSkeleton, StatusChip } from '../../components/index.js';

function tabCount(tab, counts) {
  if (tab === 'pending') return counts.pending;
  if (tab === 'roster') return counts.approved;
  return counts.inactive;
}

export function SiteAccessQueue({
  activeTab,
  counts,
  items,
  loading,
  searchValue,
  selectedEdipn,
  onAddEdipn,
  onSearchChange,
  onSelect,
  onTabChange,
  addDisabled = false,
}) {
  return (
    <section className="card flush site-access-queue" data-testid="queue-panel">
      <div className="site-access-admin__section-head">
        <div>
          <h2>Queue</h2>
          <div className="site-access-admin__assistive-copy">{tabCount(activeTab, counts)} {activeTab === 'pending' ? 'pending' : activeTab}</div>
        </div>
      </div>

      <div className="site-access-queue__tabs">
        {[
          ['pending', 'Pending'],
          ['roster', 'Roster'],
          ['inactive', 'Inactive'],
        ].map(([tab, label]) => (
          <button
            key={tab}
            type="button"
            className={`site-access-queue__tab${activeTab === tab ? ' is-active' : ''}`}
            data-testid={`queue-tab-${tab}`}
            aria-pressed={String(activeTab === tab)}
            onClick={() => onTabChange(tab)}
          >
            {label}
            <span className="site-access-queue__tab-count mono">{tabCount(tab, counts)}</span>
          </button>
        ))}
      </div>

      <div className="site-access-queue__tools">
        <input
          type="search"
          className="form-input"
          data-testid="queue-search"
          placeholder="Search EDIPN, name, org…"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
        />
        <button
          type="button"
          className="btn secondary"
          data-testid="add-edipn-button"
          disabled={addDisabled}
          onClick={onAddEdipn}
        >
          + Add EDIPN
        </button>
      </div>

      {loading ? (
        <div className="site-access-queue__loading">
          <LoadingSkeleton rows={6} />
        </div>
      ) : items.length === 0 ? (
        <div className="site-access-queue__empty" data-testid="queue-empty">
          <EmptyState
            title={activeTab === 'pending' ? 'No requests waiting' : activeTab === 'roster' ? 'No approved identities' : 'No suspended or revoked identities'}
            description={
              activeTab === 'pending'
                ? 'The pending queue is clear right now.'
                : activeTab === 'roster'
                  ? 'Approved identities appear here once access is granted.'
                  : 'Inactive identities appear here when access is denied, suspended, or revoked.'
            }
          />
        </div>
      ) : (
        <div className="site-access-queue__list" role="list" data-testid="queue-list">
          {items.map((item) => (
            <button
              key={item.edipn}
              type="button"
              className={`site-access-queue__item${selectedEdipn === item.edipn ? ' is-selected' : ''}`}
              data-testid={`queue-item-${item.edipn}`}
              aria-selected={String(selectedEdipn === item.edipn)}
              onClick={() => onSelect(item.edipn)}
            >
              <div className="site-access-queue__item-head">
                <span className="mono">{item.edipn}</span>
                <StatusChip status={item.status}>{item.status}</StatusChip>
              </div>
              <div className="site-access-queue__item-name">{item.fullName || 'Unknown CAC holder'}</div>
              <div className="site-access-queue__item-org">{item.organization || 'No organization provided'}</div>
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
